@if (config) {
<div class="ds-card">

  <!-- ── Header ──────────────────────────────────────────────────────────── -->
  @if (config.title) {
  <div class="ds-card__header">
    @if (config.headerImage) {
      <img class="ds-card__avatar" [src]="config.headerImage" alt="" />
    } @else if (config.headerIcon) {
      <span class="ds-card__header-icon">
        <i class="pi {{ config.headerIcon }}"></i>
      </span>
    } @else {
      <span class="ds-card__dot"></span>
    }
    <h4 class="ds-card__title">{{ config.title }}</h4>
  </div>
  }

  <!-- ════════════════════════════════════════════════════════════════════
       MODO GRUPOS: siempre 3 cols por grupo, con etiqueta y separador
  ════════════════════════════════════════════════════════════════════ -->
  @if (hasGroups) {
    <div class="ds-groups-layout">
      @for (group of config.groups; track group.label) {
        <section class="ds-group-block">

          <!-- Etiqueta del grupo -->
          <div class="ds-group__label-row">
            @if (group.icon) {
              <span class="ds-group__icon"
                    [style.background]="(group.accent ?? 'var(--cc-accent)') + '1a'"
                    [style.border-color]="(group.accent ?? 'var(--cc-accent)') + '44'">
                <i class="pi {{ group.icon }}" [style.color]="group.accent ?? 'var(--cc-accent)'"></i>
              </span>
            } @else {
              <span class="ds-group__pip"
                    [style.background]="group.accent ?? 'var(--cc-accent)'"
                    [style.box-shadow]="'0 0 6px ' + (group.accent ?? 'var(--cc-accent)') + '88'">
              </span>
            }
            <span class="ds-group__label" [style.color]="group.accent ?? 'var(--cc-text-muted)'">{{ group.label }}</span>
          </div>

          <!-- Grid fijo de 3 columnas -->
          <div class="ds-card__grid" style="--cols: 3">
            @for (stat of group.stats; track $index; let si = $index) {
              <div class="ds-stat"
                   [class.ds-stat--divider-right]="si < 2"
                   [class.ds-stat--has-icon]="!!stat.icon">

                @if (stat.icon) {
                  <span class="ds-stat__icon"
                        [style.background]="iconBg(stat.iconColor || '#6366f1')"
                        [style.border]="iconBorder(stat.iconColor || '#6366f1')"
                        [style.box-shadow]="iconGlow(stat.iconColor || '#6366f1')">
                    <i class="pi {{ stat.icon }}" [style.color]="stat.iconColor || 'var(--cc-accent)'"></i>
                  </span>
                }

                <span class="ds-stat__value"
                      [style.color]="isPercent(stat.value) ? pctColor(stat.value) : null"
                      [style.text-shadow]="isPercent(stat.value) ? pctGlow(stat.value) : null">
                  {{ formatValue(stat.value) }}
                </span>

                <span class="ds-stat__label">{{ stat.label }}</span>

                @if (stat.sublabel) {
                  <span class="ds-stat__sublabel">{{ stat.sublabel }}</span>
                }

                @if (isPercent(stat.value)) {
                  <div class="ds-stat__bar-track">
                    <div class="ds-stat__bar-fill"
                         [style.width]="pctWidth(stat.value)"
                         [style.background]="pctColor(stat.value)"
                         [style.box-shadow]="'0 0 6px ' + pctColor(stat.value) + '88'">
                    </div>
                  </div>
                }

              </div>
            }
          </div>
        </section>
      }
    </div>
  }

  <!-- ════════════════════════════════════════════════════════════════════
       MODO SIMPLE: lista plana de stats (retrocompatible)
  ════════════════════════════════════════════════════════════════════ -->
  @if (!hasGroups && config.stats) {
  <div class="ds-card__grid" [style.--cols]="cols">
    @for (stat of config.stats; track $index) {
    <div class="ds-stat"
         [class.ds-stat--divider-right]="isDividerRight($index)"
         [class.ds-stat--has-icon]="!!stat.icon">

      @if (stat.icon) {
        <span class="ds-stat__icon"
              [style.background]="iconBg(stat.iconColor || '#6366f1')"
              [style.border]="iconBorder(stat.iconColor || '#6366f1')"
              [style.box-shadow]="iconGlow(stat.iconColor || '#6366f1')">
          <i class="pi {{ stat.icon }}" [style.color]="stat.iconColor || 'var(--cc-accent)'"></i>
        </span>
      }

      <span class="ds-stat__value"
            [style.color]="isPercent(stat.value) ? pctColor(stat.value) : null"
            [style.text-shadow]="isPercent(stat.value) ? pctGlow(stat.value) : null">
        {{ formatValue(stat.value) }}
      </span>

      <span class="ds-stat__label">{{ stat.label }}</span>

      @if (stat.sublabel) {
        <span class="ds-stat__sublabel">{{ stat.sublabel }}</span>
      }

      @if (isPercent(stat.value)) {
        <div class="ds-stat__bar-track">
          <div class="ds-stat__bar-fill"
               [style.width]="pctWidth(stat.value)"
               [style.background]="pctColor(stat.value)"
               [style.box-shadow]="'0 0 6px ' + pctColor(stat.value) + '88'">
          </div>
        </div>
      }

    </div>
    }
  </div>
  }

</div>
}
